 

<mat-tab-group>
  <mat-tab label="Société de facturation"> <app-societe></app-societe> </mat-tab>
    <mat-tab label="Utilisateurs"> <app-staff></app-staff> </mat-tab>
    <mat-tab label="Modéles de corespondances"> <app-modele></app-modele> </mat-tab>
    <mat-tab label="Liste Produits"> <app-produits></app-produits> </mat-tab>
    <mat-tab label="Piéces Jointes"> <app-pjoints></app-pjoints> </mat-tab>
  </mat-tab-group>

 

 
